import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  filtersGrid: {
    display: 'flex',
    alignItems: 'center',
    marginRight: spacing(3)
  }
}))
